export function posixJoinDirFile(dir: string, file: string): string {
  const d = dir === '.' || dir === '' ? '' : dir.replace(/\\/g, '/').replace(/\/+$/, '');
  const f = file.replace(/\\/g, '/').replace(/^\/+/, '');
  return d ? `${d}/${f}` : f;
}

/** `user/repo` for common Git hosts; else last segment of `repoRelPath` or "Repository". */
export function formatRepoShortTitle(remoteUrl: string, repoRelPath: string): string {
  const u = remoteUrl.trim();
  if (u) {
    try {
      if (u.startsWith('git@')) {
        const colon = u.indexOf(':');
        if (colon > 0) {
          const pathPart = u.slice(colon + 1).replace(/\.git$/i, '').replace(/\/+$/, '');
          if (pathPart.includes('/')) return pathPart;
        }
      } else {
        const parsed = new URL(u);
        const p = parsed.pathname.replace(/^\//, '').replace(/\.git$/i, '');
        const parts = p.split('/').filter(Boolean);
        if (parts.length >= 2) {
          return `${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
        }
        if (parts.length === 1) return parts[0]!;
      }
    } catch {
      // fall through
    }
  }
  if (repoRelPath && repoRelPath !== '.') {
    const segments = repoRelPath.split('/').filter(Boolean);
    const last = segments[segments.length - 1];
    if (last) return last;
  }
  return 'Repository';
}

export function formatRemoteDisplayLabel(remoteUrl: string): string {
  const u = remoteUrl.trim();
  if (!u) return '';
  let hostPath = u;
  try {
    if (u.startsWith('git@')) {
      const rest = u.slice('git@'.length);
      const slash = rest.indexOf(':');
      if (slash > 0) hostPath = `${rest.slice(0, slash)}/${rest.slice(slash + 1)}`;
    } else {
      const parsed = new URL(u);
      hostPath = `${parsed.hostname}${parsed.pathname}`.replace(/\/\.git$/i, '').replace(/\.git$/i, '');
    }
  } catch {
    hostPath = u.replace(/^https?:\/\//i, '').replace(/\.git$/i, '');
  }
  return `origin · ${hostPath}`;
}
